import { TextField, TextFieldProps } from '@mui/material'
import { useController, UseControllerProps } from 'react-hook-form'
import useReactHookFormError from './useReactHookFormError'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import { FilledTextField } from './FilledTextField/FilledTextField'
import { isNil } from 'lodash-es'

function OWInput<T extends object>(
    props: {
        component?: any
        componentProps?: any
        onChangeCallback?: (e: any) => void
        onChangeCustomize?: (e: any) => void
        clearLeadingZero?: boolean
        disableShowError?: boolean
        alwaysUpperCase?: boolean
    } & TextFieldProps &
        UseControllerProps<T>,
) {
    const {
        name,
        component,
        control,
        rules,
        onChangeCallback,
        onChangeCustomize,
        error: isError,
        helperText,
        componentProps,
        clearLeadingZero = false,
        disableShowError = false,
        alwaysUpperCase = false,
        variant,
        ...other
    } = props
    const { isMobile } = useScreenSize()

    const Component = component
        ? component
        : isNil(variant) && isMobile && other?.label
        ? FilledTextField
        : TextField

    const {
        field,
        formState: { errors },
    } = useController<T>({ name, control, rules })

    const { onChange, ref, value, ...otherFields } = field
    const error = useReactHookFormError(errors, name)
    return (
        <Component
            onChange={(e: any) => {
                if (clearLeadingZero)
                    e.target.value = e.target.value.replace(/^0+/, '')
                if (alwaysUpperCase)
                    e.target.value = e.target.value.toUpperCase()
                if (onChangeCustomize) onChangeCustomize(e)
                else onChange(e)
                if (onChangeCallback) {
                    onChangeCallback(e)
                }
            }}
            {...otherFields}
            {...other}
            {...componentProps}
            value={value ?? ''}
            error={!disableShowError && (error.error || isError)}
            helperText={!disableShowError && (error.helperText || helperText)}
            ref={ref}
        />
    )
}

export default OWInput
